const obsoleteTemplates = [];

obsoleteTemplates.push({
    getInstanceProps: () => ({
        elementType: "TableFrameV1",

        allowColorBackgrounds: false,
        allowColorful: false,

        defaultData: {
            primary: {
                showTopLeftCell: true,
                showBorder: true,
                showColGridLines: true,
                showRowGridLines: true,
                showHeaderRow: true,
                showHeaderCol: true,
                autoFit: true,
                cols: [
                    {
                        index: 0,
                        style: "defaultCol",
                        break: false,
                    },
                    {
                        index: 1,
                        style: "defaultCol",
                        break: false,
                    },
                    {
                        index: 2,
                        style: "defaultCol",
                        break: false,
                    },
                    {
                        index: 3,
                        style: "defaultCol",
                        break: false,
                    },
                    {
                        index: 4,
                        style: "defaultCol",
                        break: false,
                    }
                ],
                rows: [
                    {
                        index: 0,
                        style: "defaultRow",
                        break: false,
                    },
                    {
                        index: 1,
                        style: "defaultRow",
                        break: false,
                    },
                    {
                        index: 2,
                        style: "defaultRow",
                        break: false,
                    },
                    {
                        index: 3,
                        style: "defaultRow",
                        break: false,
                    }
                ],
                cells: [
                    {
                        "row": 0,
                        "col": 0,
                    },
                    {
                        "row": 0,
                        "col": 1,
                    },
                    {
                        "row": 0,
                        "col": 2,
                    },
                    {
                        "row": 0,
                        "col": 3,
                    },
                    {
                        "row": 0,
                        "col": 4,
                    },
                    {
                        "row": 1,
                        "col": 0,
                    },
                    {
                        "row": 1,
                        "col": 1,
                    },
                    {
                        "row": 1,
                        "col": 2,
                    },
                    {
                        "row": 1,
                        "col": 3,
                    },
                    {
                        "row": 1,
                        "col": 4,
                    },
                    {
                        "row": 2,
                        "col": 0,
                    },
                    {
                        "row": 2,
                        "col": 1,
                    },
                    {
                        "row": 2,
                        "col": 2,
                    },
                    {
                        "row": 2,
                        "col": 3,
                    },
                    {
                        "row": 2,
                        "col": 4,
                    },
                    {
                        "row": 3,
                        "col": 0,
                    },
                    {
                        "row": 3,
                        "col": 1,
                    },
                    {
                        "row": 3,
                        "col": 2,
                    },
                    {
                        "row": 3,
                        "col": 3,
                    },
                    {
                        "row": 3,
                        "col": 4,
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        id: "table",
        hideTemplate: true,
        updateTemplateId: "table-v2",
        updateMigration: migrateTableToVersion2,
        updateSummaryText: "Mergeable cells, new cell styling options, support for more rows and columns, and better performance,",
        icon: "table",
        title: "Table",
        description: "Organize your data into columns and rows to present information, categorize ideas, or compare items.",
        category: "basic popular",
        tags: "traction objective goal OKR market share feature features product benefit benefits business differentiate project differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage revenue metrics business profit sales income volume expenses costs summary summarize accomplish accomplishments accomplished make a list amount total sum churn metrics financial model compare vs by categories results business update status relationship",
    })
});

function migrateTableToVersion2(canvas) {
    let table = canvas.layouter.elements.primary.table;

    table.model.tableWidth = table.calculatedProps.bounds.width / table.calculatedProps.allowedSize.width;
    table.model.tableHeight = table.calculatedProps.bounds.height / table.calculatedProps.allowedSize.height;
    table.model.tableBackgroundColor = canvas.model.layout.backgroundColor;

    if (table.model.showHeaderCol) {
        if (table.model.cols[0].style == "defaultCol") {
            table.model.cols[0].style = "headerCol";
        }
        table.model.showHeaderCol = null;
    }

    if (table.model.showHeaderRow) {
        if (table.model.rows[0].style == "defaultRow") {
            table.model.rows[0].style = "headerRow";
        }
        table.model.showHeaderRow = null;
    }

    for (let cell of table.cells) {
        if (cell.contents.type == "TableCellText") {
            cell.model.fontSize = cell.contents.calculatedProps.fontSize;
        }
        if (cell.emphasized) {
            cell.model.cellStyle = "stroke";
            cell.model.cellColor = "slide";
            cell.model.bold = true;
        }
    }
}

module.exports = obsoleteTemplates;
